module.exports = __webpack_public_path__ + "img/noshow-guide-en.02b23824.png";